import React, { useContext } from "react";
import { Button } from "@mui/material";
import { MAINTENANCE } from "../molds/CardMolds";
import Context from "../../context/Context";
import language from "../../nls/language.json";
import './Maintenance.css'
import { DateTimeFmt } from "../../utils/DataUtils";

const CardMolds = ({
  data,
  handleConfirmed,
  handleUpdate
}) => {
  
  const {
    selectedCountry
  } = useContext(Context);

  const handleStatusMold = (status) => {
    let badge = '';

    switch (status) {
      case MAINTENANCE:
        badge = 'bg-danger';
        break;
      default:
        badge = 'bg-secondary';
        break;
    }

    return (<span className={`badge ${badge}`}>{status}</span>)
  }

  function renderToolType(toolType) {
    switch (toolType) {
      case "01":
        return "MOLDE DE ANEL";
      case "02":
        return "MOLDE CHEIO";
      case "03":
        return "MOLDE BASCULANTE";
      case "04":
        return "MOLDE PRENSA";
      case "05":
        return "MOLDE FLUTUANTE";
      case "06":
        return "MOLDE HBT";
      case "07":
        return "GALGA EXTERNA";
      case "08":
        return "GALGA INTERNA";
      case "09":
        return "GABARITO USINAGEM";
      case "10":
        return "GABARITO SERIGRAFIA";
      case "11":
        return "GABARITO EMPOLVADO";
      case "12":
        return "GABARITO CURVADO";
      case "13":
        return "GABARITO CURVADO ALUMINUM";
      case "14":
        return "GABARITO RECORTE";
      case "15":
        return "GABARITO MONTAGEM";
      case "16":
        return "MATRIZ DE SILICINE";
      case "17":
        return "KB-IB33";
      case "19":
        return "SERIGRAFIA DIGITAL";
      case "20":
        return "SERIGAFIA MANUAL";
      case "21":
        return "SERIGRAFIA MANUAL+DIGITAL";
      case "22":
        return "SERIGRAFIA RUCO";
      case "23":
        return "LOGOS";
      case "24":
        return "MOLDE DE ANEL FARO";
      default:
        return "";
    }
  }

  //console.log(data);

  return (
    <div className="d-flex card-mold-manutencao-container mt-3">
      <table className="table text-center mt-0">
        <thead>
          <tr>
            <th className="th-cardmolds">{language[selectedCountry.name].Manutencao.tableHeader.lote}</th>
            <th className="th-cardmolds">{language[selectedCountry.name].Manutencao.tableHeader.codigo}</th>
            <th className="th-cardmolds">{language[selectedCountry.name].Manutencao.tableHeader.descricao}</th>
            <th className="th-cardmolds">TIPO FERRAMENTAL</th>
            <th className="th-cardmolds">{language[selectedCountry.name].Manutencao.tableHeader.estoque}</th>
            <th className="th-cardmolds">{language[selectedCountry.name].Manutencao.tableHeader.local}</th>
            <th className="th-cardmolds">{language[selectedCountry.name].Manutencao.tableHeader.passagens}</th>
            <th className="th-cardmolds">{language[selectedCountry.name].Manutencao.tableHeader.sp}</th>
            <th className="th-cardmolds">{language[selectedCountry.name].Manutencao.tableHeader.motivo}</th>
            <th className="th-cardmolds">{language[selectedCountry.name].Manutencao.tableHeader.entrada}</th>
            <th className="th-cardmolds">{language[selectedCountry.name].Manutencao.tableHeader.previsao}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{data.molde_Lote}</td>
            <td>{data.molde_Codigo}</td>
            <td>{data.molde_Descricao}</td>
            <td>{renderToolType(data.molde_ToolType)}</td>
            <td>{data.molde_SAPLocal}</td>
            <td>{handleStatusMold(data.molde_Status)}</td>
            <td>{data.molde_QtdPassagens}</td>
            <td>{data.molde_Pend_Status}</td>
            <td>{data.molde_Pend_Motivo}</td>
            <td>{DateTimeFmt(data.molde_Pend_Entrada)}</td>
            <td>{DateTimeFmt(data.molde_Pend_DataPrevisao)}</td>
          </tr>
        </tbody>
      </table>
        <div className="ms-4 justify-content-center">
          <Button
            className="w-75 mb-3"
            variant="contained"
            onClick={() => handleConfirmed(data)}
            disabled={!data.molde_Pend_DataPrevisao}
          >
            {language[selectedCountry.name].Manutencao.btn.btnLiberar}
          </Button>
          <Button
            className="w-75"
            variant="contained"
            onClick={() => handleUpdate(data, language[selectedCountry.name].Manutencao.modal.editar.title)}
          >
            {language[selectedCountry.name].Manutencao.btn.btnPrevisao}
          </Button>
        </div>
    </div>
  )
}

export default CardMolds;